"use client";

import { AppImage } from "@/src/components/NextImage";
import { cn } from "utils";
import { PLAN_GATE_MODAL_SCENE_FALLBACK_CLASS } from "@/src/screens/plan/constants/planGateBlurTokens";
import { DIAGNOSIS_UNLOCK_STEP1_BACKGROUND_SRC } from "./diagnosisUnlockModalShell";

export type DiagnosisUnlockSceneVariant = "h5-fullscreen" | "pc-modal";

type DiagnosisUnlockSceneBackgroundProps = {
  /**
   * - `h5-fullscreen`：Step 2/3 H5 铺满视口
   * - `pc-modal`：Step 2/3 PC 弹窗内层背景（absolute inset-0）
   */
  variant: DiagnosisUnlockSceneVariant;
  /** 默认与 step1 相同 {@link DIAGNOSIS_UNLOCK_STEP1_BACKGROUND_SRC} */
  backgroundSrc?: string;
  className?: string;
};

/**
 * 诊断 / 解锁步场景背景。
 *
 * 与 Step 1 `LoadingStep` 一致：**仅单层背景图**（`onboard-bg.webp`），无运行时渐变蒙层。
 *
 * Figma 源稿（`90772:39501`）虽为 image 3574 + gradient 两层，但导出资源已烘焙进 webp；
 * Plan Gate 的 `modal-bg-*.webp` 同理（见 `PlanGateModalBackground` 注释），勿再叠 `PLAN_GATE_MODAL_GRADIENT`。
 */
export function DiagnosisUnlockSceneBackground({
  variant: _variant,
  backgroundSrc = DIAGNOSIS_UNLOCK_STEP1_BACKGROUND_SRC,
  className,
}: DiagnosisUnlockSceneBackgroundProps) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 overflow-hidden",
        PLAN_GATE_MODAL_SCENE_FALLBACK_CLASS,
        className,
      )}
      data-testid="diagnosis-unlock-scene-background"
      data-figma-node-id="90772:39502"
    >
      <AppImage
        src={backgroundSrc}
        alt=""
        width={393}
        height={852}
        loading="eager"
        data-testid="diagnosis-unlock-scene-bg-img"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
    </div>
  );
}
